import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { NonAuthAxios } from "../Utilities/CommonAxios";
import { jwtDecode } from 'jwt-decode';
import showToast from "../Utilities/showToast";



const initialState = {
    postItem: [],
    isAuthenticate: false
}


export const AuthRegister = createAsyncThunk(
    "auth/register",
    async (inputData, thunkAPI) => {
        try {
            const registerResponse = await NonAuthAxios({
                url: '/register',
                method: 'post',
                payload: inputData.values
            })
            if (registerResponse.status === false) throw new Error(registerResponse?.message || registerResponse?.data?.message)
            return registerResponse;
        } catch (error) {
            showToast('error', error.message)
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    }
)

export const AuthLogin = createAsyncThunk(
    "auth/login",
    async (inputData, thunkAPI) => {
        try {
            const loginResponse = await NonAuthAxios({
                url: '/login_api',
                method: 'post',
                payload: inputData
            })
            if (loginResponse.status === false) throw new Error(loginResponse?.message || loginResponse?.data?.message)
            return loginResponse;

        } catch (error) {
            showToast('error', error.message)
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    }
)


export const AuthOtpLogin = createAsyncThunk(
    "auth/otplogin",
    async (inputData, thunkAPI) => {
        try {
            const loginResponse = await NonAuthAxios({
                url: '/otp_verify',
                method: 'post',
                payload: inputData
            })
            if (loginResponse.status === false) throw new Error(loginResponse?.message || loginResponse?.data?.message)
            return loginResponse;
        } catch (error) {
            showToast('error', error.message)
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    }
)



export const AuthSocialLogin = createAsyncThunk(
    "auth/social",
    async (inputData, thunkAPI) => {
        try {
            const loginResponse = await NonAuthAxios({
                url: '/social_login',
                method: 'post',
                payload: inputData
            })
            if (loginResponse.status === false) throw new Error(loginResponse?.message || loginResponse?.data?.message)
            return loginResponse;
        } catch (error) {
            showToast('error', error.message)
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    }
)


const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: (state) => {
            state.isAuthenticate = false;
            state.postItem = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(AuthRegister.pending, (state) => {
                state.isAuthenticate = false;
                state.postItem = []
            })
            .addCase(AuthRegister.fulfilled, (state, action) => {
                state.isAuthenticate = true;
                state.postItem = action.payload.status ? jwtDecode(action?.payload?.data) : []
                localStorage.setItem('_u', action?.payload?.data || [])
            })
            .addCase(AuthRegister.rejected, (state) => {
                state.isAuthenticate = false;
                state.postItem = []
            })
            .addCase(AuthLogin.pending, (state) => {
                state.isAuthenticate = false;
                state.postItem = [];
            })
            .addCase(AuthLogin.fulfilled, (state, action) => {
                state.isAuthenticate = true;
                state.postItem = action.payload.status ? jwtDecode(action.payload.data) : []
                localStorage.setItem('_u', action?.payload?.data || [])
            })
            .addCase(AuthLogin.rejected, (state) => {
                state.isAuthenticate = false;
                state.postItem = []
            })
            .addCase(AuthOtpLogin.pending, (state) => {
                state.isAuthenticate = false;
                state.postItem = [];
            })
            .addCase(AuthOtpLogin.fulfilled, (state, action) => {
                state.isAuthenticate = true;
                state.postItem = action.payload.status ? jwtDecode(action.payload.data) : []
                localStorage.setItem('_u', action?.payload?.data || [])
            })
            .addCase(AuthOtpLogin.rejected, (state) => {
                state.isAuthenticate = false;
                state.postItem = []
            })
            .addCase(AuthSocialLogin.pending, (state) => {
                state.isAuthenticate = false;
                state.postItem = [];
            })
            .addCase(AuthSocialLogin.fulfilled, (state, action) => {
                state.isAuthenticate = true;
                state.postItem = action.payload.status ? jwtDecode(action.payload.data) : []
                localStorage.setItem('_u', action?.payload?.data || [])
            })
            .addCase(AuthSocialLogin.rejected, (state) => {
                state.isAuthenticate = false;
                state.postItem = []
            })
    },
});


export const { logout } = authSlice.actions;
export default authSlice.reducer;